export const CarIcon = () => (
  <svg
    width="23"
    height="17"
    viewBox="0 0 23 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.01983 13.4903C3.21848 13.4903 2.56885 12.8407 2.56885 12.0394V7.06691C2.56885 6.78045 2.65364 6.5004 2.81254 6.26205L6.05967 1.39136C6.32878 0.9877 6.78182 0.745239 7.26696 0.745239H15.5178C16.0029 0.745239 16.456 0.9877 16.7251 1.39136L19.9722 6.26205C20.1311 6.5004 20.2159 6.78045 20.2159 7.06691V12.0394C20.2159 12.8407 19.5663 13.4903 18.7649 13.4903H4.01983Z"
      stroke="#113148"
      strokeWidth="1.45098"
      strokeMiterlimit="10"
    />
    <path
      d="M0.60791 6.62756H2.56869M20.2158 6.62756H22.1765"
      stroke="#113148"
      strokeWidth="1.45098"
      strokeMiterlimit="10"
    />
    <path
      d="M5.01978 6.62756H11.3923H17.7649"
      stroke="#113148"
      strokeWidth="1.45098"
      strokeMiterlimit="10"
    />
    <path
      d="M15.8041 11.5296C16.6163 11.5296 17.2747 10.8712 17.2747 10.059C17.2747 9.24678 16.6163 8.58838 15.8041 8.58838C14.9919 8.58838 14.3335 9.24678 14.3335 10.059C14.3335 10.8712 14.9919 11.5296 15.8041 11.5296Z"
      fill="#113148"
    />
    <path
      d="M6.9806 11.5296C7.79278 11.5296 8.45119 10.8712 8.45119 10.059C8.45119 9.24678 7.79278 8.58838 6.9806 8.58838C6.16841 8.58838 5.51001 9.24678 5.51001 10.059C5.51001 10.8712 6.16841 11.5296 6.9806 11.5296Z"
      fill="#113148"
    />
    <path
      d="M3.54907 13.4904V16.4315"
      stroke="#113148"
      strokeWidth="1.45098"
      strokeMiterlimit="10"
    />
    <path
      d="M19.2354 13.0001V16.4315"
      stroke="#113148"
      strokeWidth="1.45098"
      strokeMiterlimit="10"
    />
  </svg>
);
